import { useAdminVideoMutations } from './use-admin-video-mutations';
import { useVideoUploads } from './use-video-uploads';

export function useDeleteVideo() {
  const { remove } = useAdminVideoMutations();
  const { cancel, dismiss } = useVideoUploads();

  const deleteVideo = (videoId: string, onDeleted?: () => void) => {
    cancel(videoId);
    remove.mutate(videoId, {
      onSuccess: () => {
        dismiss(videoId);
        onDeleted?.();
      },
    });
  };

  return {
    deleteVideo,
    isDeleting: remove.isPending,
    error: remove.error,
  };
}
